import { ChangelogEntry, type ChangelogEntryRecord } from "./ChangelogEntry";
import { ChangelogShare } from "./ChangelogShare";

// Sprint 9.6 — WeekBlock : groupe une semaine ISO d'entrées changelog.
// Header avec label semaine + count par type + bouton Partager.

const TYPE_LABEL: Record<string, string> = {
  feature: "nouveauté",
  improvement: "amélioration",
  fix: "correctif",
  breaking: "breaking",
};

function pluralize(n: number, label: string): string {
  return `${n} ${label}${n > 1 ? "s" : ""}`;
}

export function ChangelogWeekBlock({
  weekIso,
  weekLabel,
  entries,
}: {
  weekIso: string;
  weekLabel: string;
  entries: ChangelogEntryRecord[];
}) {
  const counts: Record<string, number> = {};
  for (const e of entries) {
    counts[e.type] = (counts[e.type] ?? 0) + 1;
  }
  const summary = Object.entries(counts)
    .map(([type, n]) => pluralize(n, TYPE_LABEL[type] ?? type))
    .join(" · ");

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3 pb-2 border-b border-border">
        <div className="min-w-0">
          <p className="text-[13px] font-semibold text-foreground">
            {weekLabel}
          </p>
          <p className="text-[11.5px] text-fabrik-text-3">{summary}</p>
        </div>
        <ChangelogShare entries={entries} weekIso={weekIso} />
      </div>
      <div className="flex flex-col gap-2">
        {entries.map((entry) => (
          <ChangelogEntry key={entry.id} entry={entry} />
        ))}
      </div>
    </section>
  );
}
